import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "row pb-3" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Information:")
], -1)
const _hoisted_2 = { class: "row pb-1" }
const _hoisted_3 = { class: "row pb-1" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "row pb-3" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Staking Token:")
], -1)
const _hoisted_5 = { class: "row pb-1" }
const _hoisted_6 = { class: "flex sm12 md12 lg8" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "row pb-3" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Staking Levels:")
], -1)
const _hoisted_8 = { class: "row pb-1" }

import { Chain, ContractInfo } from "@/models/Contract";
import { Protocol } from "@/models/Protocol";
import { computed, ref } from "vue";
import ContractInput from "./contractInput.vue";

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  props: {
  protocol: { type: Protocol, required: false },
},
  emits: ["protocolUpdate"],
  setup(__props, { emit }) {

const props = __props


// eslint-disable-next-line no-undef

const activeProtocol = ref(props.protocol || new Protocol());

const description = computed({
  get(): string {
    if (!activeProtocol.value) return "";
    return activeProtocol.value.description;
  },
  set(desc: string): void {
    if (!activeProtocol.value) return;
    activeProtocol.value.description = desc;
    emit("protocolUpdate", activeProtocol.value);
  },
});

const setContract = (info: ContractInfo): void => {
  stakingAddress.value = info.address;
  stakingChain.value = info.chain;
  symbol.value = info.symbol;
};

const website = computed({
  get(): string {
    return activeProtocol.value.website;
  },
  set(newVal: string): void {
    activeProtocol.value.website = newVal;
    emit("protocolUpdate", activeProtocol.value);
  },
});

const symbol = computed({
  get(): string {
    return activeProtocol.value.symbol;
  },
  set(newVal: string): void {
    activeProtocol.value.symbol = newVal;
    emit("protocolUpdate", activeProtocol.value);
  },
});

const stakingAddress = computed({
  get(): string {
    return activeProtocol.value.userStakingAddress;
  },
  set(newVal: string): void {
    activeProtocol.value.userStakingAddress = newVal;
    emit("protocolUpdate", activeProtocol.value);
  },
});
const stakingChain = computed({
  get(): Chain {
    return activeProtocol.value.userStakingChain;
  },
  set(newVal: Chain): void {
    activeProtocol.value.userStakingChain = newVal;
    emit("protocolUpdate", activeProtocol.value);
  },
});
const goldLevel = computed({
  get(): string {
    return activeProtocol.value.goldQuantity.toString();
  },
  set(newVal: string): void {
    activeProtocol.value.goldQuantity = parseInt(newVal);
    emit("protocolUpdate", activeProtocol.value);
  },
});
const basicLevel = computed({
  get(): string {
    return activeProtocol.value.basicQuantity.toString();
  },
  set(newVal: string): void {
    if (!activeProtocol.value) return;
    activeProtocol.value.basicQuantity = parseInt(newVal);
    emit("protocolUpdate", activeProtocol.value);
  },
});

return (_ctx: any,_cache: any) => {
  const _component_va_input = _resolveComponent("va-input")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_va_input, {
        class: "flex sm12 md12 lg6 pb-1 pt-1",
        label: "Description",
        type: "textarea",
        autosize: "",
        modelValue: _unref(description),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(description) ? (description).value = $event : null))
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_va_input, {
        class: "flex sm12 md12 lg6",
        label: "Website",
        modelValue: _unref(website),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(website) ? (website).value = $event : null))
      }, null, 8, ["modelValue"])
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(ContractInput, {
          chain: _unref(stakingChain),
          initialAddress: _unref(stakingAddress),
          showToken: true,
          chainPrompt: true,
          protocol: __props.protocol,
          onContractInfo: setContract
        }, null, 8, ["chain", "initialAddress", "protocol"])
      ])
    ]),
    _hoisted_7,
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_va_input, {
        class: "flex sm2",
        label: "Gold",
        modelValue: _unref(goldLevel),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(goldLevel) ? (goldLevel).value = $event : null))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_va_input, {
        class: "flex sm2",
        label: "Basic",
        modelValue: _unref(basicLevel),
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(basicLevel) ? (basicLevel).value = $event : null))
      }, null, 8, ["modelValue"])
    ])
  ]))
}
}

})